import { Component } from '@angular/core';

import { NavController } from 'ionic-angular';

@Component({
  selector: 'page-about',
  templateUrl: 'about.html'
})
export class About {

  constructor(public navCtrl: NavController) {
    
  }

}



// WEBPACK FOOTER //
// ./src/pages/about/about.ts